import { render, staticRenderFns } from "./Koren.vue?vue&type=template&id=1d0d05d0&scoped=true&"
import script from "./Koren.vue?vue&type=script&lang=js&"
export * from "./Koren.vue?vue&type=script&lang=js&"
import style0 from "./Koren.vue?vue&type=style&index=0&id=1d0d05d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0d05d0",
  null
  
)

export default component.exports